package br.com.texeratx.boardgametimeapp.ui.components.icon

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import boardgametimeapp.composeapp.generated.resources.Res
import boardgametimeapp.composeapp.generated.resources.img_matches
import org.jetbrains.compose.resources.painterResource

@Composable
fun MatchesIcon() {
    Image(
        painter = painterResource(Res.drawable.img_matches),
        contentDescription = "Matches",
        modifier = Modifier.size(48.dp),
        contentScale = ContentScale.Fit
    )
}
